import { useSelector } from 'react-redux';
import Login from './screens/Auth/Login';
import ResetPassword from './screens/Auth/ResetPassword';
import ForgotPassword from './screens/Auth/ForgotPassword';
import ForgotPasswordOtp from './screens/Auth/ForgotPasswordOtp';
import ChangePassword from './screens/Auth/ChangePassword';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HeaderProvider } from './context/HeaderContext';
import UserList from './screens/User/UserList';
import { useState } from 'react';
import SidebarMenu from './components/Sidebar/SidebarMenu';
import UserFormHeader from './components/Sidebar/UserFormHeader';
// import UserForm from './components/Sidebar/UserForm';
import GreenAmbassadorForm from './screens/User/GreenAmbassadorForm';
import NgoForm from './screens/User/NgoForm';
import { CompanyForm } from './screens/User/CompanyForm';
import UserEdit from './screens/User/UserEdit';
import UserView from './screens/User/UserView';
import CreateChallengeCategory from './screens/Challenge/CreateChallengeCategory';
import CategoryList from './screens/Challenge/CategoryList';
import CreateChallenge from './screens/Challenge/CreateChallenge';
import ChallengeList from './screens/Challenge/ChallengeList';
// import CategoryDetails from './screens/Challenge/CategoryDetails';
import CreateProductOrServiceCategory from './screens/Products/CreateProductOrServiceCategory';
import ProductOrServiceCategoryList from './screens/Products/ProductOrServiceCategoryList';
import CreateProductOrService from './screens/Products/CreateProductOrService';
import ProductOrServiceList from './screens/Products/ProductOrServiceList';
import ChallengeSubmissions from './screens/Submissions/ChallengeSubmissions';
import IssueList from './screens/HelpDesk/IssueList';
import GreenAmbassadorEdit from './screens/User/GreenAmbassadorEdit';
import MediaLibrary from './screens/MediaLibrary/MediaLibrary';
import NgoEdit from './screens/User/NgoEdit';
import CompanyEdit from './screens/User/CompanyEdit';
import EditChallengeCategory from './screens/Challenge/EditChallengeCategory';
import UserAmbassadorList from './screens/User/UserList/UserAmbassadorList';
import NGOList from './screens/User/UserList/NGOList';
import CompaniesList from './screens/User/UserList/CompaniesList';
import Dashboard from './screens/Dashboard';
import SubmissionDetails from './screens/Submissions/SubmissionDetails';
import ProposedChallenges from './screens/Challenge/ProposedChallenges';
import ProposedChallengeDetails from './screens/Challenge/ProposedChallengeDetails';
import EditProposedChallenge from './screens/Challenge/EditProposedChallenge';
import PointsAllocationLogs from './screens/User/PointsAllocationLogs';
import BlogList from './screens/Blogs/BlogList';
import CreateBlog from './screens/Blogs/CreateBlog';
import SubmissionState from './screens/Submissions/SubmissionState';
import HomepageOrganizer from './screens/HomePageOrganizer/HomepageOrganizer';
import CreateEventCategory from './screens/Events/EventCategory/CreateEventCategory';
import EventCategoryList from './screens/Events/EventCategory/EventCategoryList';
import CreateEvent from './screens/Events/CreateEvent';
import ViewEvents from './screens/Events/ViewEvents';
import EventSubmissions from './screens/Events/EventSubmissions';
import EventSubmissionsDetails from './screens/Events/EventSubmissionsDetails';
import CreateFact from './screens/Facts/Facts/CreateFact';
import FactList from './screens/Facts/Facts/FactList';
import EcoActivityList from './screens/Facts/EcoActivities/EcoActivityList';
import EcoActivityDetails from './screens/Facts/EcoActivities/EcoActivityDetails';
import EditEcoActivityDetails from './screens/Facts/EcoActivities/EditEcoActivityDetails';
import CreateTip from './screens/KnowledgeBoard/Tips/CreateTip';
import ViewTipsList from './screens/KnowledgeBoard/Tips/ViewTipsList';
import CreateNews from './screens/KnowledgeBoard/News/CreateNews';
import ViewNewsList from './screens/KnowledgeBoard/News/ViewNewsList';
import CreateVideos from './screens/KnowledgeBoard/Videos/CreateVideos';
import ViewVideosList from './screens/KnowledgeBoard/Videos/ViewVideosList';
import CreateBadgeCategory from './screens/Badge/CreateBadgeCategory';
import BadgeCategoryList from './screens/Badge/BadgeCategoryList';
import CreateBadge from './screens/Badge/CreateBadge';
import BadgeList from './screens/Badge/BadgeList';
import CreateUser from './screens/User/UserCreation/CreateUser';
import UserBlogList from './screens/Blogs/UserBlogList';
import BlogDetails from './screens/Blogs/BlogDetails';
import CreateQuiz from './screens/Quiz/CreateQuiz';
import QuizList from './screens/Quiz/QuizList';
import ChallengeHomepageOrganizer from './screens/ChallengeHomepageOrganizer/ChallengeHomepageOrganizer';
import AppInfo from './screens/AppInfo/AppInfo';
import UserReviews from './screens/UserReviews/UserReviews';
import RewardsHomepageOrganizer from './screens/RewardsHomepageOrganizer/RewardsHomepageOrganizer';
// import CreateNewCampaign from './screens/CampaignManagement/CreateNewCampaign';
import UserChat from './screens/HelpDesk/UserChat';
import IssueCategoryList from './screens/HelpDesk/IssueCategoryList';
import RejectionReasonsList from './screens/HelpDesk/RejectionReasonsList';
import LinkChallenge from './screens/CampaignManagement/LinkChallenge';
import CreateNewCampaignCopy from './screens/CampaignManagement/CreateNewCampaignCopy';
import CampaignList from './screens/CampaignManagement/CampaignList';
import CreateCoupons from './screens/Coupons/CreateCoupons';
import ListCoupons from './screens/Coupons/ListCoupons';
import ListRequests from './screens/PartnerRequest/ListRequests';
import ModificationRequest from './screens/PartnerRequest/ModificationRequest';
import SupportTicketList from './screens/PartnerRequest/SupportTicket/SupportTicketList';
import ViewSupportTicket from './screens/PartnerRequest/SupportTicket/ViewSupportTicket';
import CreateCampaignRequestList from './screens/PartnerRequest/CreateCampaignRequest/CreateCampaignRequestList';
import CreateCampaignRequestDetails from './screens/PartnerRequest/CreateCampaignRequest/CreateCampaignRequestDetails';
import ModifyCampaignRequestList from './screens/PartnerRequest/ModifyCampaignRequest/ModifyCampaignRequestList';
import ModifyCampaignRequestDetails from './screens/PartnerRequest/ModifyCampaignRequest/ModifyCampaignRequestDetails';
import Notifications from './screens/Notifications/Notifications/Notifications';
import NotificationTypes from './screens/Notifications/NotificationTypes/NotificationTypes';
import Inquiries from './screens/HelpDesk/Inquiries';
import InquiryDetails from './screens/HelpDesk/InquiryDetails';
import NotificationsList from './screens/Notifications/Notifications/NotificationList';
import NotificationLogs from './screens/Notifications/NotificationLogs';
import UserDeletionRequests from './screens/User/UserDeletionRequests/UserDeletionRequests';
import UserDeletionRequestDetails from './screens/User/UserDeletionRequests/UserDeletionRequestDetails';
import ListAds from './screens/Advertisements/ListAds';
import CreateAd from './screens/Advertisements/CreateAd';
import ListSlots from './screens/Advertisements/ListSlots';
import CreateSlot from './screens/Advertisements/CreateSlot';
import SlotAllocationList from './screens/Advertisements/SlotAllocationList';
import AllocateSlot from './screens/Advertisements/AllocateSlot';
import CreateBrand from './screens/Brands/CreateBrand';
import ListBrands from './screens/Brands/ListBrands';
import UploadDocument from './screens/Document Repository/UploadDocument';
import DocumentList from './screens/Document Repository/DocumentList';
import AppConfigs from './screens/AppConfigs/AppConfigs';
import CouponRedemption from './screens/CouponRedemption/CouponRedemption';
import PullApi from './screens/CouponRedemption/PullApi';
import UserCoupons from './screens/Coupons/UserCoupons';
import DocumentTypes from './screens/Document Repository/DocumentTypes';
import { getAdminType } from './utils/adminType';
import AssignBadge from './screens/Badge/AssignBadge';
import ListAdmins from './screens/Admin/ListAdmins';
import CreateProject from './screens/Project/CreateProject';
import ListProjects from './screens/Project/ListProjects';
import ProjectPlantation from './screens/Project/ProjectPlantation';
import ProjectPlantationDetails from './screens/Project/ProjectPlantationDetails';
import UserGuide from './screens/UserGuide/UserGuide';
import ReleaseNotes from './screens/ReleaseNotes/ReleaseNotes';
import HelpButton from './tour/HelpButton';

function App() {
  const userState = useSelector((state) => state.user);
  const authState = useSelector((state) => state.auth);
  // console.log(userState);
  const adminType = getAdminType();

  const [activeItem, setActiveItem] = useState("users-list");
  const [selectedTab, setSelectedTab] = useState("users-list");
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    try { return localStorage.getItem('cc_sidebar_collapsed') === 'true'; }
    catch (_) { return false; }
  });
  const toggleSidebar = () => {
    setSidebarCollapsed(prev => {
      const next = !prev;
      try { localStorage.setItem('cc_sidebar_collapsed', String(next)); } catch (_) {}
      return next;
    });
  };

  // console.log(selectedTab);

  return (
    <div className="App flex">
      <BrowserRouter>
        <HeaderProvider>
          {userState.isLoggedIn ? (
            <div className="w-full">
              <UserFormHeader />
              <div className="app-main flex justify-between w-full">
                <SidebarMenu
                  activeItem={activeItem}
                  setActiveItem={setActiveItem}
                  selectedTab={selectedTab}
                  setSelectedTab={setSelectedTab}
                  collapsed={sidebarCollapsed}
                  onToggle={toggleSidebar}
                />
                <div
                  className={`${sidebarCollapsed ? 'ml-[72px]' : 'ml-64'} w-full mt-5 mb-5 px-4 transition-[margin] duration-300 ease-in-out`}
                  style={{ width: "-webkit-fill-available" }}
                >
                  <Routes>
                    <Route path='/dashboard' element={<Dashboard />} />
                    <Route path='/change-password' element={<ChangePassword />} />
                    <Route path='/page-organizer'>
                      <Route path='homepage-organizer' element={<HomepageOrganizer />} />
                      <Route path='challenge-homepage-organizer' element={<ChallengeHomepageOrganizer />} />
                      <Route path='rewards-homepage-organizer' element={<RewardsHomepageOrganizer />} />
                    </Route>
                    <Route path='/app-configs'>
                      <Route path='configs' element={<AppConfigs />} />
                      <Route path='info' element={<AppInfo />} />
                    </Route>
                    <Route path='/user-reviews' element={<UserReviews />} />
                    <Route path='/user'>
                      <Route path='list'>
                        {/* <Route path='all-users' element={<UserList />} /> */}
                        <Route path='app-users' element={<UserList />} />
                        <Route path='ambassadors' element={<UserAmbassadorList />} />
                        <Route path='ngos' element={<NGOList />} />
                        <Route path='companies' element={<CompaniesList />} />
                      </Route>
                      <Route path='create'>
                        <Route path='user' element={<CreateUser />} />
                        <Route path='ambassador' element={<GreenAmbassadorForm />} />
                        <Route path='ngo' element={<NgoForm />} />
                        <Route path='company' element={<CompanyForm />} />
                      </Route>
                      <Route path="edit">
                        <Route path="user" element={<UserEdit />} />
                        <Route
                          path="ambassador"
                          element={<GreenAmbassadorEdit />}
                        />
                        <Route path="ngo" element={<NgoEdit />} />
                        <Route path="company" element={<CompanyEdit />} />
                      </Route>
                      <Route path="view">
                        <Route path="user" element={<UserView />} />
                        <Route path="ambassador" element={<UserView />} />
                        <Route path="ngo" element={<UserView />} />
                        <Route path="company" element={<UserView />} />
                      </Route>
                      <Route
                        path="point-allocation-log"
                        element={<PointsAllocationLogs />}
                      />
                      <Route
                        path="delete-list"
                        element={<UserDeletionRequests />}
                      />
                      <Route
                        path="delete-request-details"
                        element={<UserDeletionRequestDetails />}
                      />
                    </Route>

                    <Route path="/admins">
                      <Route
                        path="list-admins"
                        element={<ListAdmins />}
                      />
                    </Route>

                    <Route path="/challenges">
                      <Route path="challenge-categories">
                        <Route
                          path="create-categories"
                          element={<CreateChallengeCategory />}
                        />
                        <Route
                          path="view-categories"
                          element={<CategoryList />}
                        />
                      </Route>
                      <Route path="challenges-main">
                        <Route
                          path="create-challenge"
                          element={<CreateChallenge />}
                        />
                        <Route
                          path="edit-challenge"
                          element={<CreateChallenge />}
                        />
                        <Route
                          path="view-challenges"
                          element={<ChallengeList />}
                        />
                      </Route>
                      <Route
                        path="proposed-challenges"
                        element={<ProposedChallenges />}
                      />
                      <Route
                        path="proposed-challenges-details"
                        element={<ProposedChallengeDetails />}
                      />
                      <Route
                        path="proposed-challenges-edit"
                        element={<EditProposedChallenge />}
                      />
                      <Route path="edit">
                        <Route
                          path="category"
                          element={<EditChallengeCategory />}
                        />
                        <Route path="challenges" element={<UserView />} />
                      </Route>
                    </Route>

                    <Route path="/products">
                      <Route path="product-categories">
                        <Route
                          path="create-product-categories"
                          element={<CreateProductOrServiceCategory />}
                        />
                        <Route
                          path="view-product-categories"
                          element={<ProductOrServiceCategoryList />}
                        />
                      </Route>
                      <Route path="products-main">
                        <Route
                          path="create-products"
                          element={<CreateProductOrService />}
                        />
                        <Route
                          path="view-products"
                          element={<ProductOrServiceList />}
                        />
                      </Route>
                      {/* <Route path="view">
                        <Route
                          path="category"
                          element={<CategoryDetails />}
                        />
                        <Route path="challenges" element={<UserView />} />
                      </Route> */}
                    </Route>

                    <Route path="/submissions">
                      <Route
                        path="challenge-submission"
                        element={<ChallengeSubmissions />}
                      />
                      <Route
                        path="challenge-submission-details"
                        element={<SubmissionDetails />}
                      />
                      <Route
                        path="challenge-submission-details-state"
                        element={<SubmissionState />}
                      />
                    </Route>

                    <Route path="/events">
                      <Route path="event-categories">
                        <Route
                          path="create-categories"
                          element={<CreateEventCategory />}
                        />
                        <Route
                          path="view-categories"
                          element={<EventCategoryList />}
                        />
                      </Route>
                      <Route path="events-main">
                        <Route
                          path="create-event"
                          element={<CreateEvent />}
                        />
                        <Route path="view-events" element={<ViewEvents />} />
                      </Route>
                      <Route
                        path="events-submissions"
                        element={<EventSubmissions />}
                      />
                      <Route
                        path="events-submissions-details"
                        element={<EventSubmissionsDetails />}
                      />
                    </Route>

                    <Route path="/help-desk">
                      <Route
                        path="issues"
                        element={<IssueList />}
                      />
                      <Route
                        path="issue-category"
                        element={<IssueCategoryList />}
                      />
                      <Route
                        path="user-chat/:id"
                        element={<UserChat />}
                      />
                      <Route
                        path="inquiries"
                        element={<Inquiries />}
                      />
                      <Route
                        path="inquiry-details/:id"
                        element={<InquiryDetails />}
                      />
                    </Route>


                    <Route path="/media-library" element={<MediaLibrary />} />
                    <Route path="/user-guide" element={<UserGuide />} />
                    <Route path="/release-notes" element={<ReleaseNotes />} />

                    <Route
                      path="*"
                      element={<Navigate to="/dashboard" replace />}
                    />

                    <Route path='/blogs'>
                      <Route path='create-blog' element={<CreateBlog />} />
                      <Route path='edit-blog' element={<CreateBlog />} />
                      <Route path='blog-details' element={<BlogDetails />} />
                      <Route path='blog-list-admin' element={<BlogList />} />
                      <Route path='blog-list-user' element={<UserBlogList />} />
                    </Route>

                    <Route path="/fact-details">
                      <Route path="create-fact" element={<CreateFact />} />
                      <Route path="list-facts" element={<FactList />} />
                    </Route>
                    <Route path='/eco-activity'>
                      {/* <Route index path='create-eco-activity' element={<CreateEvent />} /> */}
                      <Route path='list-eco-activity' element={<EcoActivityList />} />
                      <Route path='eco-activity-details' element={<EcoActivityDetails />} />
                      <Route path='edit-eco-activity-details' element={<EditEcoActivityDetails />} />
                    </Route>

                    <Route path="/knowledge-board">
                      <Route path="tips">
                        <Route path="create-tips" element={<CreateTip />} />
                        <Route path="list-tips" element={<ViewTipsList />} />
                      </Route>
                      <Route path="videos">
                        <Route
                          path="create-videos"
                          element={<CreateVideos />}
                        />
                        <Route path="list-videos" element={<ViewVideosList />} />
                      </Route>
                      <Route path="news">
                        <Route
                          path="create-news"
                          element={<CreateNews />}
                        />
                        <Route path="list-news" element={<ViewNewsList />} />
                      </Route>
                    </Route>

                    <Route path="/badge">
                      <Route path="badge-categories">
                        <Route
                          path="create-categories"
                          element={<CreateBadgeCategory />}
                        />
                        <Route
                          path="view-categories"
                          element={<BadgeCategoryList />}
                        />
                      </Route>
                      <Route path="badge-main">
                        <Route
                          path="create-badge"
                          element={<CreateBadge />}
                        />
                        <Route path="view-badges" element={<BadgeList />} />
                        <Route path="assign-badge" element={<AssignBadge />} />
                      </Route>
                    </Route>

                    <Route path='/quiz'>
                      <Route path='create-quiz' element={<CreateQuiz />} />
                      <Route path='quiz-list' element={<QuizList />} />
                    </Route>

                    <Route path='/notifications'>
                      <Route path='notification-types' element={adminType === 'superadmin' ? <NotificationTypes /> : <Dashboard />} />
                      <Route path='notifications-list' element={<Notifications />} />
                      <Route path='admin-notifications-list' element={<NotificationsList />} />
                      <Route path='notification-logs' element={<NotificationLogs />} />
                    </Route>

                    <Route path='/campaign-management'>
                      {/* <Route path='new-campaign' element={<CreateNewCampaign />} /> */}
                      <Route path='new-campaign' element={<CreateNewCampaignCopy />} />
                      <Route path='list-campaign' element={<CampaignList />} />
                      <Route path='create-coupon' element={<CreateCoupons />} />
                      <Route path='challenge-sponsor' element={<LinkChallenge />} />
                    </Route>

                    <Route path='/coupons'>
                      <Route path='create-coupon' element={<CreateCoupons />} />
                      <Route path='list-coupon' element={<ListCoupons />} />
                      <Route path='user-coupons' element={<UserCoupons />} />
                    </Route>

                    <Route path='/brands'>
                      <Route path='create-brand' element={<CreateBrand />} />
                      <Route path='list-brand' element={<ListBrands />} />
                    </Route>

                    <Route path='/projects'>
                      <Route path='create-project' element={<CreateProject />} />
                      <Route path='list-projects' element={<ListProjects />} />
                      <Route path='plantation-project' element={<ProjectPlantation />} />
                      <Route path='plantation-project-details' element={<ProjectPlantationDetails />} />
                    </Route>

                    <Route path="/advertisements">
                      <Route path='ads-management'>
                        <Route path="create-ad" element={<CreateAd />} />
                        <Route path="list-ads" element={<ListAds />} />
                      </Route>
                      <Route path='slots-management'>
                        <Route path="create-slot" element={<CreateSlot />} />
                        <Route path="list-slots" element={<ListSlots />} />
                      </Route>
                      <Route path="slot-allocations" element={<SlotAllocationList />} />
                      <Route path="allocate-slot" element={<AllocateSlot />} />
                    </Route>

                    <Route path='/requests'>
                      <Route path='create-request' element={<CreateCampaignRequestList />} />
                      <Route path='create-request-details' element={<CreateCampaignRequestDetails />} />
                      <Route path='modification-request' element={<ModifyCampaignRequestList />} />
                      <Route path='modification-request-details' element={<ModifyCampaignRequestDetails />} />
                      <Route path='support-tickets' element={<SupportTicketList />} />
                      <Route path='view-ticket' element={<ViewSupportTicket />} />
                      <Route path='list-requests' element={<ListRequests />} />
                    </Route>

                    <Route path='/document-repository'>
                      <Route path='upload' element={<UploadDocument />} />
                      <Route path='document-types' element={<DocumentTypes />} />
                      <Route path='document-list' element={<DocumentList />} />
                    </Route>

                  </Routes>
                </div>
              </div>
            </div>
          ) : (
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/webooktest" element={<CouponRedemption />} />
              <Route path="/pullapitest" element={<PullApi />} />
              <Route
                path="/resetpassword"
                element={authState.otp ? <ResetPassword /> : <Login />}
              />
              <Route path="/forgotpassword" element={<ForgotPassword />} />
              <Route
                path="/forgotpasswordotp"
                element={
                  authState.passwordReset ? <ForgotPasswordOtp /> : <Login />
                }
              />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          )}
        </HeaderProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
